import React from "react";
import Marquee from "react-fast-marquee";

export default function Ribbon({ text }) {
  const phrase = text || "Spaces you feel, not just see ·";
  return (
    <div data-testid="marquee" className="bg-background border-y border-border py-8 md:py-12 overflow-hidden">
      <Marquee speed={38} gradient={false} autoFill>
        <span className="font-serif font-light text-3xl md:text-5xl text-foreground/80 tracking-tight px-8">
          {phrase}
        </span>
      </Marquee>
    </div>
  );
}
